<div id="passport" class="root passportData" fxLayout="column" >
  <div class="overflow-y-scroll p-md-2" *ngIf="(dataState | async)">
    <div *ngIf="(!isEditMode || readonly); then display_mode; else edit_mode"></div>
    <ng-template #display_mode>
      <app-display
        [profile]="profile"
        [communityPassport]="readonly"
        [favouriteEvents]="favouriteEvents"
        (refreshEventState)="handleRefreshEventState($event)"
        (editProfile)="editProfile($event)"
      ></app-display>
    </ng-template>
    <ng-template #edit_mode>
      <app-edit
        [profile]="profile"
        (editProfile)="editProfile($event)"
      ></app-edit>
    </ng-template>

    <div class="separator"></div>
    <section id="passport-details" class="py-5" *ngIf="profile">
      <div class="d-flex flex-row justify-content-between position mb-4">
        <div class="heading gold mt-2" style="color: #d7be69;">My Passport</div>
        <div class="d-flex flex-column form-group">
          <span class="mb-2 mt-2 fs-6">Select Year / Edition</span>
          <select #seasonSelect [(ngModel)]="spotlightYear" class="form-control fw-bold" (change)="selectChange()">
            <option value="--Select Year--">--Select Year--</option>
            <option label="{{spotyear.season}} {{spotyear.year}}" value="{{spotyear.season}} {{spotyear.year}}"
              *ngFor="let spotyear of spotlightsData">
              {{spotyear.season}} {{spotyear.year}}
            </option>
          </select>
          <span class="ms-auto fs-7 mt-2">Stamps: {{eventLength}}</span>
        </div>
      </div>
      <div fxLayout="column">
        <app-stamps-box label="Spotlight Events" [stamps]="spotlights" [eventType]="eventTypes.spotlight"
          (refreshEventState)="handleRefreshEventState($event)"
          [communityPassport]="readonly ? profile : null" comingSoonImage="assets/images/passport/spotlight/comingsoon.png">
        </app-stamps-box>
        <app-stamps-box label="Showcase Films" [stamps]="showcases" [eventType]="eventTypes.showcase"
          (refreshEventState)="handleRefreshEventState($event)"
          [communityPassport]="readonly ? profile : null" comingSoonImage="assets/images/passport/showcase/comingsoon.png">
        </app-stamps-box>
        <app-stamps-box label="Screening Parties" [stamps]="screeningparties" [eventType]="eventTypes.screeningParty"
          [communityPassport]="readonly ? profile : null"
          (refreshEventState)="handleRefreshEventState($event)"
          comingSoonImage="assets/images/passport/screeningparty/comingsoon.png"></app-stamps-box>
      </div>
    </section>
  </div>
</div>
